import { IconProps } from "@/assets/CadwellIcons.tsx";

export function UserIcon({size = 24, style, ...others}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 12 12"
      style={{width: size, height: size, ...style}}
      {...others}
    >
      <path d="M10.6364 11.0001H9.96229C9.96229 8.85287 8.21541 7.10599 6.0682 7.10599C3.92099 7.10599 2.17422 8.85287 2.17422 11.0001H1.5C1.5 8.4811 3.54932 6.43188 6.0682 6.43188C8.58718 6.43188 10.6364 8.4811 10.6364 11.0001Z" fill="currentColor"/>
      <path d="M6.06825 6.16531C4.64415 6.16531 3.4856 5.00676 3.4856 3.58265C3.4856 2.15855 4.64415 1 6.06825 1C7.49224 1 8.6509 2.15855 8.6509 3.58265C8.6509 5.00676 7.49224 6.16531 6.06825 6.16531ZM6.06825 1.67411C5.01592 1.67411 4.15981 2.53021 4.15981 3.58254C4.15981 4.63487 5.01592 5.49109 6.06825 5.49109C7.12058 5.49109 7.97668 4.63498 7.97668 3.58254C7.97668 2.53033 7.12058 1.67411 6.06825 1.67411Z" fill="currentColor"/>
    </svg>
  );
}
